import { Statistics } from '@models';

export interface FoundationStatisticsResult {
  foundationStatistics: Statistics;
}
